import { render, staticRenderFns } from "./ReservationTimePromotionPopup.vue?vue&type=template&id=064555b0&"
import script from "./ReservationTimePromotionPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationTimePromotionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports